import { render, staticRenderFns } from "./RelatedOrderPanel.vue?vue&type=template&id=38d5dcbe&scoped=true&"
import script from "./RelatedOrderPanel.vue?vue&type=script&lang=ts&"
export * from "./RelatedOrderPanel.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedOrderPanel.vue?vue&type=style&index=0&id=38d5dcbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5dcbe",
  null
  
)

export default component.exports